module.exports = __webpack_public_path__ + "media/site/images/products/actionplan-screen2-df0ddea9c53e2697e04a22a567d42302.png";